import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  formControl: {
    position: 'fixed',
    bottom: '0px',
    right: '14%',
    zIndex: 30,
  },
  selectRoot: {
    display: 'inline-flex',
    alignItems: 'center',
    height: 25,
    paddingBottom: '12px',

    '& > svg': {
      top: 'calc(50% - .75em)',
    },
  },
  select: {
    borderRadius: '0px 4px',
    paddingTop: '15px',
    paddingBottom: '12px',
    backgroundColor: '#E8E8E8 !important',

    '&:focus-visible': {
      outline: 'none',
    },

    '&:focus': {
      backgroundColor: 'transparent',
    },
  },
  menuItem: {
    height: 30,
    '&:focus-visible': {
      outline: 'none',
    },
  },
}));
